import { jsx as _jsx } from "react/jsx-runtime";
import { useResolvedUrl, parseUrlScheme } from './useResolvedUrl';
import { CodeBlockPlaceholder } from './CodeBlockPlaceholder';
/**
 * Markdown image component with support for custom URL schemes.
 * Handles artifact: and image: URLs with loading states and error handling.
 */
export function MarkdownImage({ node, src, alt, className, artifactRunId, ExistingImg, ...rest }) {
    const rawSrc = src || '';
    const { scheme } = parseUrlScheme(rawSrc);
    // For standard URLs, delegate to existing component or render directly
    if (scheme === 'standard') {
        if (typeof ExistingImg === 'function') {
            return _jsx(ExistingImg, { node: node, src: src, alt: alt, ...rest });
        }
        return _jsx("img", { src: src, alt: alt, className: className, ...rest });
    }
    // For artifact: and image: URLs, use the resolver
    return (_jsx(ResolvedImage, { rawSrc: rawSrc, alt: alt, artifactRunId: artifactRunId, className: className, rest: rest }));
}
/**
 * Internal component for images that need async URL resolution
 */
function ResolvedImage({ rawSrc, alt, artifactRunId, className, rest, }) {
    const { url, isLoading, error, retry } = useResolvedUrl({
        rawUrl: rawSrc,
        artifactRunId,
        disposition: 'inline',
    });
    if (isLoading) {
        return _jsx(CodeBlockPlaceholder, { type: "image", message: alt ? `Loading ${alt}...` : undefined });
    }
    if (error) {
        return (_jsx(CodeBlockPlaceholder, { type: "image", error: error, onRetry: retry }));
    }
    if (!url) {
        return null;
    }
    return _jsx("img", { src: url, alt: alt, className: className, ...rest });
}
//# sourceMappingURL=MarkdownImage.js.map